import React, {useState} from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {
	IncomingRealTimePayment,
	IncomingRealTimePaymentRejectReason,
	rejectIncomingRealTimePayment,
} from "../../resources/incomingRealTimePayment"
import Select from "react-select"

interface RejectIncomingRtpModalProps {
	incomingRtp: IncomingRealTimePayment
	close: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function RejectIncomingRtpModal({incomingRtp, close, onSuccess}: RejectIncomingRtpModalProps) {
	const accessToken = useAccessToken()
	const [state, reject] = useAsyncResultIdle(rejectIncomingRealTimePayment)

	const instructionId = incomingRtp.attributes.instructionId
	const idempotencyKey = `reject-${incomingRtp.id}`
	const [reason, setReason] = useState<IncomingRealTimePaymentRejectReason | null>(null)

	const reasonOptions = Object.values(IncomingRealTimePaymentRejectReason).map((reason) => ({
		value: reason,
		label: reason,
	}))

	return (
		<AsyncResultModal
			title="Reject Incoming Payment"
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-danger"
			state={state}
			buttonText="Reject"
			successText="Rejected"
			buttonDisabled={!reason}
			enableClickAway={false}
			onSubmit={() =>
				reject(
					accessToken,
					incomingRtp.id,
					instructionId,
					idempotencyKey,
					reason as IncomingRealTimePaymentRejectReason
				)
			}
			errorToText={(err) => err.errors[0].title}
		>
			<div className="field">
				<label className="label">Reject reason code</label>
				<div className="control">
					<Select
						options={reasonOptions}
						value={reason ? {value: reason, label: reason} : null}
						onChange={(e) => setReason(e?.value as IncomingRealTimePaymentRejectReason)}
						menuPortalTarget={document.body}
						menuPosition="fixed"
						styles={{
							menuPortal: (base) => ({...base, zIndex: 10000}),
						}}
					/>
				</div>
			</div>
		</AsyncResultModal>
	)
}
